module.exports = __webpack_public_path__ + "static/media/3-Cassv-Reading-Group.671ba3f3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/images/3-Cassv-Reading-Group.jpg
// module id = 139
// module chunks = 0